export default __webpack_public_path__ + "static/media/home-restaurant-img-03.dd3ce9cc.png";